import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'
import {
  OrderListApiResponse,
  OrderListApiRequest,
  OrderDetailApiData,
  IOrderDownloadExcelParams,
  OrderExportApiResponse,
  ReceiptDownloadApiResponse,
} from '../types'

/** 订单列表 */
export const fetchOrderList = (param: OrderListApiRequest) => request.get<OrderListApiResponse>(`${HOSTS.BASE}/api/entweb/order/search`, { params: param })

export const fetchOrderDetail = (param: {bizOrderId: number}) => request.get<OrderDetailApiData>(`${HOSTS.BASE}/api/entweb/order/detail`, { params: param })

// 导出订单
export const fetchOrderDownloadExcel = (param: IOrderDownloadExcelParams) => request.post<OrderExportApiResponse>(`${HOSTS.BASE}/api/entweb/importExport/order/export`, param)

// 下载收据
export const fetchReceiptDownload = (params: {
  bizId: string,
  locale?: string,
  type: number
}) => request.post<ReceiptDownloadApiResponse>(`${HOSTS.BASE}/api/entweb/receipt/downLoad`, params)
